/** biome-ignore-all lint/performance/noImgElement: We need to use img elements here for the credit card icons because we're importing SVGs */

import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { CreditCardIcon } from '~/components/Workspace/Checkout/PaymentFields/CreditCardIcon';

export type CreditCardsIconsProps = Pick<ComponentProps<'div'>, 'className'>;

export const CreditCardsIcons = memo(({ className }: CreditCardsIconsProps) => (
  <div className={cn('flex gap-2', className)}>
    <CreditCardIcon brand="American Express" />
    <CreditCardIcon brand="MasterCard" />
    <CreditCardIcon brand="Visa" />
  </div>
));

CreditCardsIcons.displayName = 'CreditCardsIcons';
